import { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { trainingSessionsAPI } from '../../services/api.js';

export const useSessionManager = (
  trainingGroupId,
  selectedSessions,
  dateRange,
  showScheduledSessions
) => {
  const [sessions, setSessions] = useState([]);
  const [selectedSessionsList, setSelectedSessionsList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSessions();
  }, [trainingGroupId, dateRange, showScheduledSessions]);

  useEffect(() => {
    if (selectedSessions && selectedSessions.length > 0) {
      const sessionIds = selectedSessions.map((session) =>
        typeof session === 'object' ? session.id : session
      );
      setSelectedSessionsList(sessionIds);
    } else {
      setSelectedSessionsList([]);
    }
  }, [selectedSessions]);

  const loadSessions = async () => {
    try {
      setLoading(true);
      const params = {
        training_group_id: trainingGroupId,
        start_date: format(dateRange.start, 'yyyy-MM-dd'),
        end_date: format(dateRange.end, 'yyyy-MM-dd'),
        for_autoplanner: true,
      };

      if (!showScheduledSessions) {
        params.include_scheduled = false;
      }

      const response = await trainingSessionsAPI.getSessions(params);
      // Sort sessions by date to ensure consistent ordering
      const sortedSessions = response.sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return dateA.getTime() - dateB.getTime();
      });
      setSessions(sortedSessions);
    } catch (error) {
      console.error('Error loading sessions:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSessionSelect = (sessionId) => {
    setSelectedSessionsList((prev) => {
      if (prev.includes(sessionId)) {
        return prev.filter((id) => id !== sessionId);
      } else {
        return [...prev, sessionId];
      }
    });
  };

  const handleSelectAllSessions = () => {
    const allSessionIds = sessions.map((session) => session.id);
    setSelectedSessionsList(allSessionIds);
  };

  return {
    sessions,
    selectedSessionsList,
    loading,
    handleSessionSelect,
    handleSelectAllSessions,
    setSelectedSessionsList,
  };
};
